module.exports = __webpack_public_path__ + "media/brands/eagle-e597fda0.png";